/* ============================================================
   PESTOFF Theme JS
   ============================================================ */
(function () {
  'use strict';

  // === NAV DRAWER ===
  var drawer = document.querySelector('[data-nav-drawer]');
  var drawerToggle = document.querySelector('[data-nav-toggle]');
  var drawerClose = document.querySelector('[data-nav-close]');
  var overlay = document.querySelector('[data-overlay]');

  function openDrawer() {
    if (drawer) drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (drawerToggle) drawerToggle.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // === ANNOUNCEMENT BAR ROTATION ===
  var bar = document.querySelector('[data-announcement]');
  if (bar) {
    var slides = bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length > 1) {
      var idx = 0;
      slides.forEach(function(s, i) { s.style.display = i === 0 ? 'block' : 'none'; });
      setInterval(function () {
        slides[idx].style.opacity = '0';
        setTimeout(function () {
          slides[idx].style.display = 'none';
          idx = (idx + 1) % slides.length;
          slides[idx].style.display = 'block';
          slides[idx].style.opacity = '0';
          setTimeout(function () { slides[idx].style.opacity = '1'; }, 20);
        }, 400);
      }, 4000);
    }
  }

  // === PRODUCT GALLERY ===
  (function() {
    var gallery = document.getElementById('productGallery');
    if (!gallery) return;

    var slides    = Array.from(gallery.querySelectorAll('.gallery-slide'));
    var thumbEls  = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn   = document.getElementById('galleryPrev');
    var nextBtn   = document.getElementById('galleryNext');
    var progressBar = document.getElementById('galleryProgressBar');

    if (slides.length === 0) return;

    var current  = 0;
    var total    = slides.length;
    var INTERVAL = 4000; // ms per slide
    var timer, progressTimer;

    function goTo(idx) {
      slides[current].classList.remove('is-active');
      thumbEls[current] && thumbEls[current].classList.remove('is-active');

      current = (idx + total) % total;

      slides[current].classList.add('is-active');
      thumbEls[current] && thumbEls[current].classList.add('is-active');

      // scroll thumb into view
      if (thumbEls[current]) {
        thumbEls[current].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }

      startProgress();
    }

    function startProgress() {
      if (!progressBar) return;
      clearInterval(progressTimer);
      progressBar.style.transition = 'none';
      progressBar.style.width = '0%';
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          progressBar.style.transition = 'width ' + INTERVAL + 'ms linear';
          progressBar.style.width = '100%';
        });
      });
    }

    function startAuto() {
      clearInterval(timer);
      timer = setInterval(function() { goTo(current + 1); }, INTERVAL);
    }

    // Arrows
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

    // Thumbnails
    thumbEls.forEach(function(th) {
      th.addEventListener('click', function() {
        goTo(parseInt(th.getAttribute('data-index')));
      });
    });

    // Touch swipe
    var touchStartX = 0;
    gallery.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { goTo(diff > 0 ? current + 1 : current - 1); }
    });

    // Init — no auto-rotate, hide progress bar
    var pb = document.getElementById('galleryProgress');
    if (pb) pb.style.display = 'none';
  })();

  // === BUNDLE SELECTOR — price display only (cart logic handled in AJAX section) ===
  var bundleOpts = document.querySelectorAll('[data-bundle-opt]');
  var priceDisplay = document.getElementById('priceDisplay');
  var priceOld     = document.getElementById('priceOld');
  var stickyPrice  = document.getElementById('stickyPrice');
  var stickyOld    = document.getElementById('stickyOld');

  bundleOpts.forEach(function (opt) {
    opt.addEventListener('click', function () {
      bundleOpts.forEach(function (o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
      var price    = opt.getAttribute('data-price');
      var oldPrice = opt.getAttribute('data-old-price');
      if (priceDisplay) priceDisplay.textContent = price + ' ₪';
      if (priceOld)     priceOld.textContent     = oldPrice + ' ₪';
      if (stickyPrice)  stickyPrice.textContent  = price + ' ₪';
      if (stickyOld)    stickyOld.textContent    = oldPrice + ' ₪';
    });
  });

  // === FAQ ACCORDION ===
  document.querySelectorAll('[data-faq-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var item = toggle.closest('[data-faq-item]');
      if (!item) return;
      var isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('[data-faq-item]').forEach(function (i) {
        i.classList.remove('open');
      });
      // Toggle clicked
      if (!isOpen) item.classList.add('open');
    });
  });

  // === CART QUANTITY BUTTONS ===
  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      if (input) { input.value = parseInt(input.value || 1) + 1; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input');
      if (input) { var v = parseInt(input.value || 1) - 1; input.value = v < 1 ? 1 : v; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  });

  // === AUTO-UPDATE CART ===
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    var t;
    input.addEventListener('change', function () {
      clearTimeout(t);
      t = setTimeout(function () { input.closest('form').submit(); }, 300);
    });
  });

  // === AJAX ADD TO CART ===
  (function() {
    var variantIdEl = document.getElementById('productVariantId');
    var qtyEl       = document.getElementById('productQty');
    var btnBuyNow   = document.getElementById('btnBuyNow');
    var btnAddCart  = document.getElementById('btnAddCart');
    var stickyBtn   = document.querySelector('.sticky-btn');

    if (!variantIdEl) return;

    function getVariantId() {
      // Try hidden input first, then window fallback
      var id = parseInt(variantIdEl.value, 10);
      if (!id && window.__pestoffVariantId) id = window.__pestoffVariantId;
      return id || null;
    }
    function getQty() {
      return parseInt(qtyEl ? qtyEl.value : '1', 10) || 1;
    }

    function setLoading(btn, loading) {
      if (!btn) return;
      btn.disabled = loading;
      if (loading) {
        btn.setAttribute('data-orig', btn.innerHTML);
        if (btn.id === 'btnBuyNow') {
          btn.querySelector('span').textContent = 'מוסיף לסל...';
        } else {
          btn.innerHTML = 'מוסיף...';
        }
      } else {
        var orig = btn.getAttribute('data-orig');
        if (orig) btn.innerHTML = orig;
        btn.disabled = false;
      }
    }

    function addToCart(variantId, qty, callback) {
      if (!variantId) return;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.status) return; // Shopify returned an error object — ignore silently
          return fetch('/cart.js');
        })
        .then(function(r) { if (r) return r.json(); })
        .then(function(cart) {
          if (!cart) return;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          if (callback) callback(cart);
        })
        .catch(function() { /* silent */ });
    }

    // "להזמנה עכשיו" — add to cart + open drawer
    if (btnBuyNow) {
      btnBuyNow.addEventListener('click', function() {
        var id  = getVariantId();
        var qty = getQty();
        setLoading(btnBuyNow, true);
        addToCart(id, qty, function() {
          setLoading(btnBuyNow, false);
          // drawer opens via cart:updated event
        });
        // Fallback: reset loading after 5s
        setTimeout(function() { setLoading(btnBuyNow, false); }, 5000);
      });
    }

    // "הוסף לסל" — add to cart + open drawer (same as above, no redirect)
    if (btnAddCart) {
      btnAddCart.addEventListener('click', function() {
        var id  = getVariantId();
        var qty = getQty();
        setLoading(btnAddCart, true);
        addToCart(id, qty, function() {
          setLoading(btnAddCart, false);
        });
        setTimeout(function() { setLoading(btnAddCart, false); }, 5000);
      });
    }

    // Sticky button
    if (stickyBtn) {
      stickyBtn.removeAttribute('onclick');
      stickyBtn.addEventListener('click', function() {
        if (btnBuyNow) btnBuyNow.click();
      });
    }

    // Bundle opts update hidden variant + qty + displayed price
    document.querySelectorAll('[data-bundle-opt]').forEach(function(opt) {
      opt.addEventListener('click', function() {
        var qty     = opt.getAttribute('data-qty');
        var variant = opt.getAttribute('data-variant');
        var price   = opt.getAttribute('data-price');
        var oldp    = opt.getAttribute('data-old-price');
        if (qtyEl && qty)           qtyEl.value       = qty;
        if (variantIdEl && variant) variantIdEl.value = variant;
        var pd = document.getElementById('priceDisplay');
        var po = document.getElementById('priceOld');
        var sp = document.getElementById('stickyPrice');
        var so = document.getElementById('stickyOld');
        if (pd && price) pd.textContent = price + ' ₪';
        if (po) po.textContent = oldp ? (oldp + ' ₪') : '';
        if (sp && price) sp.textContent = price + ' ₪';
        if (so) so.textContent = oldp ? (oldp + ' ₪') : '';
        document.querySelectorAll('[data-bundle-opt]').forEach(function(o){ o.classList.remove('selected'); });
        opt.classList.add('selected');
      });
    });
  })();

  // === SMOOTH SCROLL ===
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    var href = a.getAttribute('href');
    if (href.length > 1) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector(href);
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
    }
  });

  // === REVIEWS CAROUSEL ===
  var carousel = document.querySelector('[data-reviews-carousel]');
  if (carousel) {
    var groups  = Array.from(carousel.querySelectorAll('.reviews-group'));
    var dots    = Array.from(carousel.querySelectorAll('[data-dot]'));
    var current = 0;
    var interval = parseInt(carousel.getAttribute('data-interval')) || 8000;
    var timer;

    if (groups.length < 2) return; // nothing to rotate

    // hide all except first
    groups.forEach(function(g, i) {
      g.style.display = i === 0 ? 'grid' : 'none';
      g.style.opacity = i === 0 ? '1' : '0';
    });

    function goTo(next) {
      if (next === current) return;
      var prev = current;
      current = next;

      // update dots
      dots.forEach(function(d, i) {
        d.classList.toggle('is-active', i === next);
      });

      // fade out old
      groups[prev].style.transition = 'opacity 0.4s ease, transform 0.4s ease';
      groups[prev].style.opacity = '0';
      groups[prev].style.transform = 'translateY(-10px)';

      setTimeout(function() {
        groups[prev].style.display = 'none';
        groups[prev].style.transform = '';
        groups[prev].style.transition = '';

        // fade in new
        groups[next].style.opacity = '0';
        groups[next].style.transform = 'translateY(16px)';
        groups[next].style.display = 'grid';

        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            groups[next].style.transition = 'opacity 0.5s ease, transform 0.5s ease';
            groups[next].style.opacity = '1';
            groups[next].style.transform = 'translateY(0)';
          });
        });
      }, 420);
    }

    function advance() { goTo((current + 1) % groups.length); }

    function startTimer() {
      clearInterval(timer);
      timer = setInterval(advance, interval);
    }

    carousel.addEventListener('mouseenter', function() { clearInterval(timer); });
    carousel.addEventListener('mouseleave', startTimer);

    startTimer();
  }

  // === SEARCH BAR ===
  var searchToggle = document.getElementById('searchToggle');
  var searchBar = document.getElementById('headerSearchBar');
  var searchInput = document.getElementById('headerSearchInput');
  var searchClear = document.getElementById('searchClear');

  function openSearch() {
    searchBar.classList.add('is-open');
    searchBar.setAttribute('aria-hidden', 'false');
    searchToggle.classList.add('is-active');
    searchToggle.setAttribute('aria-expanded', 'true');
    setTimeout(function () { if (searchInput) searchInput.focus(); }, 200);
  }

  function closeSearch() {
    searchBar.classList.remove('is-open');
    searchBar.setAttribute('aria-hidden', 'true');
    searchToggle.classList.remove('is-active');
    searchToggle.setAttribute('aria-expanded', 'false');
  }

  if (searchToggle) {
    searchToggle.addEventListener('click', function () {
      var isOpen = searchBar.classList.contains('is-open');
      if (isOpen) { closeSearch(); } else { openSearch(); }
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      if (searchInput.value.length > 0) {
        searchClear.classList.add('is-visible');
      } else {
        searchClear.classList.remove('is-visible');
      }
    });
  }

  if (searchClear) {
    searchClear.addEventListener('click', function () {
      searchInput.value = '';
      searchClear.classList.remove('is-visible');
      searchInput.focus();
    });
  }

  // סגור חיפוש בלחיצה מחוץ לכותרת
  document.addEventListener('click', function (e) {
    if (!searchBar || !searchToggle) return;
    if (!searchBar.contains(e.target) && !searchToggle.contains(e.target)) {
      closeSearch();
    }
  });

  // סגור חיפוש ב-Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSearch();
  });

  // === SCROLL TO TOP ===
  var scrollBtn = document.getElementById('scrollTopBtn');
  if (scrollBtn) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 400) {
        scrollBtn.classList.add('is-visible');
      } else {
        scrollBtn.classList.remove('is-visible');
      }
    }, { passive: true });
    scrollBtn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  // === CART DRAWER ===
  var cartDrawer = document.getElementById('cartDrawer');
  var cartDrawerOverlay = document.getElementById('cartDrawerOverlay');
  var cartDrawerClose = document.getElementById('cartDrawerClose');
  var cartDrawerBody = document.getElementById('cartDrawerBody');
  var cartDrawerFooter = document.getElementById('cartDrawerFooter');
  var cartDrawerTitle = document.getElementById('cartDrawerTitle');
  var cartDrawerTotal = document.getElementById('cartDrawerTotal');
  var cartDrawerSavings = document.getElementById('cartDrawerSavings');
  var cartDrawerSavingsAmt = document.getElementById('cartDrawerSavingsAmt');

  function formatPrice(cents) {
    return '₪ ' + (cents / 100).toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function openCartDrawer() {
    fetchCart();
    cartDrawer.classList.add('is-open');
    cartDrawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
    cartDrawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);

  // intercept all cart icon clicks
  document.querySelectorAll('.header__icon--cart, [data-cart-icon]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  function fetchCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) { renderCart(cart); })
      .catch(function() {});
  }

  function renderCart(cart) {
    var itemCount = cart.item_count;
    cartDrawerTitle.textContent = 'עגלה • ' + (itemCount === 1 ? 'פריט 1' : 'פריטים ' + itemCount);

    if (itemCount === 0) {
      cartDrawerBody.innerHTML = '<div class="cart-drawer__empty"><div style="font-size:40px;margin-bottom:12px;">🛒</div><div>העגלה שלך ריקה</div><a href="/products/12432354">להמשיך בקנייה</a></div>';
      if (cartDrawerFooter) cartDrawerFooter.style.display = 'none';
      return;
    }

    // ===== Rewards bar (3-step gamification) =====
    var FREE_SHIP = 14900, GIFT_TIER = 25000;
    var ctotal = cart.total_price;
    var fillpct;
    if (ctotal >= GIFT_TIER) { fillpct = 100; }
    else if (ctotal >= FREE_SHIP) { fillpct = 50 + Math.round((ctotal - FREE_SHIP) * 50 / (GIFT_TIER - FREE_SHIP)); }
    else { fillpct = Math.max(4, Math.round(ctotal * 50 / FREE_SHIP)); }
    var s2 = ctotal >= FREE_SHIP, s3 = ctotal >= GIFT_TIER;
    var rwdMsg;
    if (s3) { rwdMsg = '<span class="cd2__win">✨ פתחתם את כל ההטבות!</span>'; }
    else if (s2) { rwdMsg = 'זכיתם במשלוח חינם! עוד <strong>' + formatPrice(GIFT_TIER - ctotal) + '</strong> ותקבלו מדריך מתנה 🎁'; }
    else { rwdMsg = 'עוד <strong>' + formatPrice(FREE_SHIP - ctotal) + '</strong> ותזכו ב<strong>משלוח חינם</strong> 🚚'; }

    var IC_BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
    var IC_TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="14" height="12" rx="1.5"/><path d="M15 8h4l3 3v5h-7z"/><circle cx="6" cy="18.5" r="2"/><circle cx="18" cy="18.5" r="2"/></svg>';
    var IC_GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9"/><line x1="12" y1="8" x2="12" y2="22"/><path d="M12 8S11 2 8 2a2.5 2.5 0 0 0 0 5z"/><path d="M12 8s1-6 4-6a2.5 2.5 0 0 1 0 5z"/></svg>';

    var html = '<div class="cd2__rewards">'
      + '<div class="cd2__rail"><div class="cd2__fill" style="width:' + fillpct + '%"></div></div>'
      + '<div class="cd2__steps">'
      +   '<div class="cd2__step is-done"><div class="cd2__dot">' + IC_BAG + '</div><div class="cd2__lbl">העגלה</div></div>'
      +   '<div class="cd2__step ' + (s2 ? 'is-done' : '') + '"><div class="cd2__dot">' + IC_TRUCK + '</div><div class="cd2__lbl">משלוח חינם</div></div>'
      +   '<div class="cd2__step ' + (s3 ? 'is-done' : '') + '"><div class="cd2__dot">' + IC_GIFT + '</div><div class="cd2__lbl">מתנה</div></div>'
      + '</div>'
      + '<div class="cd2__msg">' + rwdMsg + '</div>'
      + '</div>';

    var TRASH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>';

    html += '<div class="cd2__items">';

    // final_line_price reflects line-level discounts (buy-2-get-2) but NOT the
    // cart-level discount (the extra 10%). Spread it pro-rata so each line shows
    // its real post-discount price and the lines sum to the final total.
    var subtotal = cart.items_subtotal_price || 0;

    cart.items.forEach(function(item, idx) {
      var lineNum = idx + 1;
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + item.product_title + '">'
        : '';

      var displayLinePrice = subtotal > 0
        ? Math.round(item.final_line_price * cart.total_price / subtotal)
        : item.final_line_price;
      var origLinePrice = item.original_price * item.quantity;
      var hasDisc = origLinePrice > displayLinePrice;
      var oldHtml = hasDisc ? '<span class="cd2__old">' + formatPrice(origLinePrice) + '</span>' : '';
      var saveHtml = hasDisc ? '<span class="cd2__save">חסכת ' + formatPrice(origLinePrice - displayLinePrice) + '</span>' : '';

      var variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cd2__variant">' + item.variant_title + '</div>'
        : '';

      var pills = '';
      if (item.discounts && item.discounts.length) {
        item.discounts.forEach(function(d) { pills += '<span class="cd2__pill">🏷️ ' + d.title + '</span>'; });
      }

      html += '<div class="cd2__card" data-line="' + lineNum + '">'
        + '<div class="cd2__media">' + imgHtml + '</div>'
        + '<div class="cd2__info">'
        +   '<div class="cd2__name">' + item.product_title + '</div>'
        +   variantHtml + pills
        +   '<div class="cd2__row2">'
        +     '<div class="cd2__qty">'
        +       '<button type="button" class="cd-qty-btn" data-line="' + lineNum + '" data-delta="-1" aria-label="הפחת">−</button>'
        +       '<input type="number" class="cd-qty-input" data-line="' + lineNum + '" value="' + item.quantity + '" min="0" max="99">'
        +       '<button type="button" class="cd-qty-btn" data-line="' + lineNum + '" data-delta="1" aria-label="הוסף">+</button>'
        +     '</div>'
        +     '<button type="button" class="cd2__del cd-remove-btn" data-line="' + lineNum + '" aria-label="הסר">' + TRASH + '</button>'
        +   '</div>'
        + '</div>'
        + '<div class="cd2__money">' + oldHtml + '<span class="cd2__now">' + formatPrice(displayLinePrice) + '</span>' + saveHtml + '</div>'
        + '</div>';
    });
    html += '</div>';
    cartDrawerBody.innerHTML = html;

    // total & savings
    var total = cart.total_price;
    cartDrawerTotal.textContent = formatPrice(total);
    if (cartDrawerFooter) cartDrawerFooter.style.display = 'block';

    var savings = cart.original_total_price - cart.total_price;
    if (savings > 0 && cartDrawerSavings && cartDrawerSavingsAmt) {
      cartDrawerSavings.style.display = 'flex';
      cartDrawerSavingsAmt.textContent = formatPrice(savings);
    } else if (cartDrawerSavings) {
      cartDrawerSavings.style.display = 'none';
    }

    // +/- buttons
    cartDrawerBody.querySelectorAll('.cd-qty-btn').forEach(function(btn) {
      btn.onclick = function() {
        var line  = parseInt(btn.getAttribute('data-line'), 10);
        var delta = parseInt(btn.getAttribute('data-delta'), 10);
        var inp   = cartDrawerBody.querySelector('.cd-qty-input[data-line="' + line + '"]');
        var cur   = inp ? parseInt(inp.value, 10) : 1;
        updateCartItem(line, Math.max(0, cur + delta));
      };
    });

    // Manual qty input
    cartDrawerBody.querySelectorAll('.cd-qty-input').forEach(function(inp) {
      inp.onchange = function() {
        var line = parseInt(inp.getAttribute('data-line'), 10);
        var qty  = parseInt(inp.value, 10);
        if (!isNaN(qty) && qty >= 0) updateCartItem(line, qty);
      };
    });

    // Remove buttons
    cartDrawerBody.querySelectorAll('.cd-remove-btn').forEach(function(btn) {
      btn.onclick = function() {
        var line = parseInt(btn.getAttribute('data-line'), 10);
        updateCartItem(line, 0);
      };
    });
  }

  function updateCartItem(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        renderCart(cart);
        updateCartCount(cart.item_count);
      })
      .catch(function() {});
  }

  function updateCartCount(count) {
    var badge = document.querySelector('.header__cart-count');
    if (!badge) return;
    if (count > 0) {
      badge.textContent = count;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  // open cart drawer after add to cart
  document.addEventListener('cart:updated', function(e) {
    if (e.detail && e.detail.cart) {
      renderCart(e.detail.cart);
      updateCartCount(e.detail.cart.item_count);
    }
    openCartDrawer();
  });

  // Customers-love marquee handled by CSS animation (@keyframes clMarquee)

  // === PRODUCT REVIEWS — FORM + PAGINATION ===
  (function() {
    var writeBtn   = document.getElementById('prWriteBtn');
    var formWrap   = document.getElementById('prFormWrap');
    var cancelBtn  = document.getElementById('prCancelBtn');
    var submitBtn  = document.getElementById('prSubmitBtn');
    var successBox = document.getElementById('prFormSuccess');
    var starPicker = document.getElementById('prStarPicker');
    var ratingInput = document.getElementById('prRatingVal');
    var titleInput = document.getElementById('prTitleInput');
    var titleCount = document.getElementById('prTitleCount');
    var fileInput  = document.getElementById('prFileInput');
    var fileName   = document.getElementById('prFileName');
    var list       = document.getElementById('prList');
    var pagination = document.getElementById('prPagination');

    var PER_PAGE   = 5;
    var currentPage = 1;

    // ---- Form toggle ----
    function openForm() {
      if (!formWrap) return;
      formWrap.removeAttribute('hidden');
      requestAnimationFrame(function() {
        formWrap.classList.add('is-open');
      });
      if (writeBtn) {
        writeBtn.textContent = 'ביטול';
        writeBtn.setAttribute('aria-expanded', 'true');
      }
    }
    function closeForm() {
      if (!formWrap) return;
      formWrap.classList.remove('is-open');
      if (writeBtn) {
        writeBtn.textContent = writeBtn.getAttribute('data-label') || 'כתבו ביקורת';
        writeBtn.setAttribute('aria-expanded', 'false');
      }
      setTimeout(function() { formWrap.setAttribute('hidden', ''); }, 500);
    }

    if (writeBtn) {
      writeBtn.setAttribute('data-label', writeBtn.textContent.trim());
      writeBtn.addEventListener('click', function() {
        var isOpen = formWrap && formWrap.classList.contains('is-open');
        if (isOpen) { closeForm(); } else { openForm(); }
      });
    }
    if (cancelBtn) cancelBtn.addEventListener('click', closeForm);

    // ---- Interactive star picker ----
    if (starPicker) {
      var stars = starPicker.querySelectorAll('.pr-star-pick');
      function highlightStars(val) {
        stars.forEach(function(s) {
          s.classList.toggle('is-active', parseInt(s.getAttribute('data-val'), 10) <= val);
        });
      }
      stars.forEach(function(s) {
        s.addEventListener('mouseenter', function() {
          highlightStars(parseInt(s.getAttribute('data-val'), 10));
        });
        s.addEventListener('mouseleave', function() {
          highlightStars(parseInt(ratingInput ? ratingInput.value : '0', 10));
        });
        s.addEventListener('click', function() {
          var val = parseInt(s.getAttribute('data-val'), 10);
          if (ratingInput) ratingInput.value = val;
          highlightStars(val);
        });
      });
    }

    // ---- Title char count ----
    if (titleInput && titleCount) {
      titleInput.addEventListener('input', function() {
        titleCount.textContent = '(' + (100 - titleInput.value.length) + ')';
      });
    }

    // ---- File picker label ----
    if (fileInput && fileName) {
      fileInput.addEventListener('change', function() {
        fileName.textContent = fileInput.files[0] ? fileInput.files[0].name : 'העלאת קובץ';
      });
    }

    // ---- Form submit ----
    if (submitBtn) {
      submitBtn.addEventListener('click', function() {
        // Simple validation
        var rating = ratingInput ? parseInt(ratingInput.value, 10) : 0;
        var body   = document.getElementById('prBodyInput');
        var name   = document.getElementById('prNameInput');
        var email  = document.getElementById('prEmailInput');

        if (rating < 1) { alert('נא לבחור דירוג בין 1 ל-5 כוכבים'); return; }
        if (body && body.value.trim().length < 10) { alert('נא לכתוב לפחות 10 תווים בתוכן הביקורת'); return; }
        if (name && name.value.trim() === '') { alert('נא להזין שם תצוגה'); return; }
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value)) { alert('נא להזין כתובת אימייל תקינה'); return; }

        // Show success
        var formInner = submitBtn.closest('.pr-form');
        if (formInner) {
          var inputs = formInner.querySelectorAll('.pr-form-group, .pr-form-row, .pr-form-privacy, .pr-form-actions, .pr-form-title');
          inputs.forEach(function(el) { el.style.display = 'none'; });
        }
        if (successBox) successBox.removeAttribute('hidden');
        setTimeout(function() { closeForm(); }, 3000);
      });
    }

    // ---- Pagination ----
    if (!list || !pagination) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('.pr-item'));
    var total = items.length;
    if (total <= PER_PAGE) return; // no pagination needed

    var totalPages = Math.ceil(total / PER_PAGE);

    function showPage(page, scroll) {
      currentPage = page;
      var start = (page - 1) * PER_PAGE;
      var end   = start + PER_PAGE;
      items.forEach(function(item, i) {
        item.classList.toggle('pr-hidden', i < start || i >= end);
      });
      buildPagination();
      // Only scroll when user clicks a pagination button
      if (scroll) {
        var section = list.closest('.product-reviews-section');
        if (section) {
          window.scrollTo({ top: section.getBoundingClientRect().top + window.pageYOffset - 100, behavior: 'smooth' });
        }
      }
    }

    function buildPagination() {
      pagination.innerHTML = '';

      // First + Prev
      var first = makeBtn('«', currentPage > 1, function() { showPage(1, true); });
      var prev  = makeBtn('‹', currentPage > 1, function() { showPage(currentPage - 1, true); });
      pagination.appendChild(first);
      pagination.appendChild(prev);

      // Page numbers
      for (var p = 1; p <= totalPages; p++) {
        (function(pg) {
          var btn = makeBtn(String(pg), true, function() { showPage(pg, true); });
          if (pg === currentPage) btn.classList.add('is-active');
          pagination.appendChild(btn);
        })(p);
      }

      // Next + Last
      var next = makeBtn('›', currentPage < totalPages, function() { showPage(currentPage + 1, true); });
      var last = makeBtn('»', currentPage < totalPages, function() { showPage(totalPages, true); });
      pagination.appendChild(next);
      pagination.appendChild(last);
    }

    function makeBtn(label, enabled, onClick) {
      var btn = document.createElement('button');
      btn.className = 'pr-page-btn';
      btn.textContent = label;
      btn.type = 'button';
      if (!enabled) { btn.disabled = true; }
      else { btn.addEventListener('click', onClick); }
      return btn;
    }

    // Init — no scroll on first load
    showPage(1, false);
  })();

})();

/* ============================================================
   CART PAGE — Global qty functions (inline onclick in HTML)
   ============================================================ */
window.cpMoney = function(cents) {
  return '\u20AA' + (cents / 100).toFixed(2).replace(/\.00$/, '');
};

window.cpChangeQty = function(lineIndex, delta) {
  var qEl    = document.querySelector('[data-cp-qty="' + lineIndex + '"]');
  var cur    = qEl ? parseInt(qEl.textContent, 10) : 1;
  var newQty = Math.max(0, cur + delta);

  // Visual feedback — disable touched buttons
  document.querySelectorAll('[data-cp-line="' + lineIndex + '"]').forEach(function(b) {
    b.disabled = true;
    b.style.opacity = '0.5';
  });

  fetch('/cart/change.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ line: lineIndex, quantity: newQty })
  })
  .then(function(r) {
    if (!r.ok) return r.json().then(function(e) { throw new Error(e.description || e.message || 'שגיאה'); });
    return r.json();
  })
  .then(function(cart) {
    // Re-enable buttons
    document.querySelectorAll('[data-cp-line]').forEach(function(b) { b.disabled = false; b.style.opacity = ''; });

    if (newQty === 0) {
      var row = document.querySelector('[data-cp-item="' + lineIndex + '"]');
      if (row) row.remove();
      // Renumber remaining rows
      document.querySelectorAll('[data-cp-item]').forEach(function(el, i) {
        var n = i + 1;
        el.setAttribute('data-cp-item', n);
        el.querySelectorAll('[data-cp-line]').forEach(function(b)  { b.setAttribute('data-cp-line',  n); });
        el.querySelectorAll('[data-cp-qty]').forEach(function(s)   { s.setAttribute('data-cp-qty',   n); });
        el.querySelectorAll('[data-cp-price]').forEach(function(d) { d.setAttribute('data-cp-price', n); });
      });
      if (cart.item_count === 0) { location.reload(); return; }
    }

    // Update totals + lines
    var fmt = window.cpMoney(cart.total_price);
    document.querySelectorAll('[data-cp-subtotal]').forEach(function(el) { el.textContent = fmt; });
    document.querySelectorAll('[data-cp-total]').forEach(function(el)    { el.textContent = fmt; });
    cart.items.forEach(function(item, i) {
      var idx = i + 1;
      var q = document.querySelector('[data-cp-qty="'   + idx + '"]');
      var p = document.querySelector('[data-cp-price="' + idx + '"]');
      if (q) q.textContent = item.quantity;
      if (p) p.textContent = window.cpMoney(item.line_price);
    });

    // Update header badge
    var badge = document.querySelector('.header__cart-count');
    if (badge) { badge.textContent = cart.item_count; badge.style.display = cart.item_count > 0 ? 'flex' : 'none'; }
  })
  .catch(function(err) {
    document.querySelectorAll('[data-cp-line]').forEach(function(b) { b.disabled = false; b.style.opacity = ''; });
    // fallback: reload page so native form handles it
    location.reload();
  });
};
